import {
  ObjectChartsData,
  ObjectChartsDataDto,
} from '../model/types/objectChartsSchema';
import {
  ObjectStatistics,
  ObjectStatisticsDto,
} from '../model/types/objectStatistics';
import {
  PriceSquareAnalytics,
  PriceSquareAnalyticsDto,
} from '../model/types/priceSquareAnalyticsSchema';

export const mapPriceSquareAnalyticsFromDto = ({
  avg_price_sale,
  avg_price_sold,
  avg_square_sale,
  avg_square_sold,
  sale_percent,
}: PriceSquareAnalyticsDto): PriceSquareAnalytics => ({
  averagePriceSale: avg_price_sale,
  averagePriceSold: avg_price_sold,
  averageSquareSale: avg_square_sale,
  averageSquareSold: avg_square_sold,
  salePercent: sale_percent,
});

export const mapObjectViewsAnalyticsFromDto = ({
  click_contacts,
  count_likes,
  favorites,
  opened_selection_lot,
  opened_selection_object,
  views,
}: ObjectChartsDataDto): ObjectChartsData => ({
  clickContacts: click_contacts,
  countLikes: count_likes,
  favorites,
  openedSelectionLot: opened_selection_lot,
  openedSelectionObject: opened_selection_object,
  views,
});

export const mapObjectStatisticsFromDto = ({
  count_selection,
  count_selection_percent,
  count_views,
  count_views_percent,
  favorites,
  favorites_percent,
  last_updated,
}: ObjectStatisticsDto): ObjectStatistics => ({
  countSelection: count_selection,
  countSelectionPercent: count_selection_percent,
  countViews: count_views,
  countViewsPercent: count_views_percent,
  favorites,
  favoritesPercent: favorites_percent,
  lastUpdated: last_updated,
});
